import { initializeApp } from 'firebase/app'
import { getToken, getMessaging, onMessage } from 'firebase/messaging'

// Used when the build has no REACT_APP_FIREBASE_* values (e.g. CI secrets not
// set yet), so existing deployments keep working. Public web config.
const FALLBACK_CONFIG = {
  apiKey: 'AIzaSyAunUOL1GUysVeFhSl_HkBaTGRB5Iol4v0',
  authDomain: 'revvit-458e3.firebaseapp.com',
  projectId: 'revvit-458e3',
  storageBucket: 'revvit-458e3.appspot.com',
  messagingSenderId: '1060935585982',
  appId: '1:1060935585982:web:f32647fd08798eddafceef',
  measurementId: 'G-WP27HVF4TE',
}

// All-or-nothing: mixing env values with the fallback project would break
// token registration.
const firebaseConfig = process.env.REACT_APP_FIREBASE_PROJECT_ID
  ? {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
      measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    }
  : FALLBACK_CONFIG

// Public key; the fallback keeps builds without the env var working.
const VAPID_KEY =
  process.env.REACT_APP_FIREBASE_VAPID_KEY ||
  'BMHNmZ22kF9Tccg3Qczbpq1eAD_1jPdullfK-i2_4k_N4nj5cpMTkl6Ao-qyGBAx3Llm27XjyDSl3Z8gs0isXBs'

const firebaseApp = initializeApp(firebaseConfig)
const messaging = getMessaging(firebaseApp)

export const getOrRegisterServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    // Always register: it is idempotent for the same URL + scope, and it
    // replaces older registrations of /firebase-messaging-sw.js without the
    // config query string (the worker reads its Firebase config from it).
    const searchParams = new URLSearchParams(
      Object.entries(firebaseConfig).map(([key, value]) => [key, value || '']),
    ).toString()

    return window.navigator.serviceWorker.register(
      `/firebase-messaging-sw.js?${searchParams}`,
      {
        scope: '/firebase-push-notification-scope',
      },
    )
  }
  throw new Error('The browser doesn`t support service worker.')
}

export const getFirebaseToken = () =>
  getOrRegisterServiceWorker().then((serviceWorkerRegistration) =>
    getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration,
    }),
  )

/**
 * Show foreground pushes (tab visible) as an OS notification. Firebase calls
 * this only while a tab is visible; otherwise the service worker shows it,
 * so each push shows exactly one notification. Returns an unsubscribe fn.
 */
export const subscribeForegroundMessages = (onNotificationClick) =>
  onMessage(messaging, (payload) => {
    const title = payload.notification?.title || payload.data?.title
    const body = payload.notification?.body || payload.data?.body || ''
    if (!title && !body) return

    if (!('Notification' in window) || Notification.permission !== 'granted') {
      console.log('Notification permission has not been granted.')
      return
    }

    const options = { body, icon: '/favicon.ico', data: payload.data || {} }
    try {
      const notification = new Notification(title || 'Revvit Admin', options)
      notification.onclick = (event) => {
        event.preventDefault()
        window.focus()
        onNotificationClick?.(payload.data || {})
        notification.close()
      }
    } catch {
      // Some browsers only allow notifications from a service worker; its
      // notificationclick handler opens the target page.
      getOrRegisterServiceWorker()
        .then((registration) =>
          registration.showNotification(title || 'Revvit Admin', options),
        )
        .catch((error) => console.warn('Notification display failed:', error))
    }
  })
